import React, { FC } from "react";
import NavLinks from "../../../navbar/links/NavLinks";
import { navLinks } from "../../../navbar/links/links-data";
import { logo } from "../../../../assets";

import "./FooterNav.css";

const FooterNav: FC = () => {
  return (
    <div className="footer-nav">
      <NavLinks
        navLinks={navLinks}
        navLinksClassName="footer-nav-links"
        navLinkClassName="footer-nav-link"
        navLinkActiveClassName="footer-nav-link active"
      />
    </div>
  );
};

export default FooterNav;
